import { mediaUrl } from "@/lib/api";
import { Heart, Check, Maximize2, Trash2 } from "lucide-react";

export function PhotoMasonry({
  photos, onOpen, selectable = false, favoritable = false,
  onToggleSelect, onToggleFavorite, watermark = false,
  deletable = false, onDelete,
}) {
  return (
    <div className="masonry" data-testid="photo-masonry">
      {photos.map((p, i) => {
        const selected = p.selected;
        return (
          <div key={p.id} className={`group relative rounded-xl overflow-hidden border cursor-pointer hover-lift ${selected ? "border-gold ring-2 ring-gold/50" : "border-white/8"}`}>
            <img
              src={mediaUrl(p.url)} alt={p.original_filename || "Photo"} loading="lazy"
              onClick={() => onOpen(i)} data-testid={`photo-${p.id}`}
              className="w-full object-cover select-none"
              onContextMenu={(e) => watermark && e.preventDefault()}
            />
            {watermark && (
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-20">
                <span className="font-serif text-white text-lg rotate-[-20deg] tracking-widest">PMR Events</span>
              </div>
            )}
            {typeof p.match_score === "number" && (
              <div className="absolute top-2 left-2 glass-dark rounded-full px-2 py-0.5 text-[10px] text-gold">
                {Math.round(p.match_score * 100)}% match
              </div>
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute top-2 right-2 flex gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
              {favoritable && (
                <button data-testid={`fav-${p.id}`} onClick={(e) => { e.stopPropagation(); onToggleFavorite?.(p); }}
                  className="w-8 h-8 rounded-full glass-dark flex items-center justify-center hover:scale-110 transition-transform">
                  <Heart className={`w-4 h-4 ${p.favorite ? "text-gold fill-gold" : "text-white"}`} />
                </button>
              )}
              <button onClick={(e) => { e.stopPropagation(); onOpen(i); }}
                className="w-8 h-8 rounded-full glass-dark flex items-center justify-center hover:scale-110 transition-transform">
                <Maximize2 className="w-3.5 h-3.5 text-white" />
              </button>
              {deletable && (
                <button data-testid={`delete-${p.id}`} onClick={(e) => { e.stopPropagation(); onDelete?.(p); }}
                  className="w-8 h-8 rounded-full glass-dark flex items-center justify-center hover:scale-110 transition-transform hover:text-destructive">
                  <Trash2 className="w-3.5 h-3.5 text-white" />
                </button>
              )}
            </div>
            {selectable && (
              <button data-testid={`select-${p.id}`} onClick={(e) => { e.stopPropagation(); onToggleSelect?.(p); }}
                className={`absolute bottom-2 left-2 flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-all ${selected ? "bg-gold text-black" : "glass-dark text-white opacity-0 group-hover:opacity-100"}`}>
                <Check className="w-3.5 h-3.5" strokeWidth={3} /> {selected ? "Selected" : "Select"}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
